<template>
	<div id="app">
		<router-view />
		<transition name="fade">
			<ProfileEdit v-if="isModalProfileEditVisible" />
		</transition>
		<transition name="fade">
			<div class="busyoverlay" v-if="isAppBusy">
				<div class="busyloader">
					<div><div></div><div></div><div></div><div></div></div>
				</div>
			</div>
		</transition>
		<transition name="fade">
			<div class="successFeedback" v-if="feedbackShowSucces">
				<div><div></div></div>
			</div>
		</transition>
		<Notifications />
	</div>
</template>

<script>
	import ProfileEdit from "@/components/profile/ProfileEdit.vue"
	import Notifications from "@/components/common/Notifications.vue"

	export default {
		name: "app",
		components: {
			ProfileEdit,
			Notifications
		}
	}
</script>

<style lang="scss">
	@import "../scss/global.scss";
	@import "https://cdn.quilljs.com/1.2.6/quill.snow.css";
</style>
